// extracted by mini-css-extract-plugin
export default {"section":"section--HheU9d5puO"};